import { ConferenciaComponent } from './../conferencia/conferencia.component';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FeriaEscolarComponent } from '../feria-escolar/feria-escolar.component';

@Component({
  selector: 'app-evento-feria-escolar',
  templateUrl: './evento-feria-escolar.component.html',
  styleUrls: ['./evento-feria-escolar.component.scss'],
})
export class EventoFeriaEscolarComponent implements OnInit {
  constructor(
    private router: Router,
    private dialog: MatDialog,
    public dialogRefEvento: MatDialogRef<EventoFeriaEscolarComponent>
  ) {}

  ngOnInit(): void {}

  openEConferenciaModal() {
    const dialogRef = this.dialog.open(FeriaEscolarComponent, {
      width: '700px',
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
    this.dialogRefEvento.close();
  }
  onCancel(): void {
    this.dialogRefEvento.close();
  }
}
